import type { MechtaIDUser } from '@mechta-dev/mechta-id-js'
import { defineStore } from 'pinia'

interface IState {
  token: string
  passCode: string
  passCodeSubject: string
  subject: string
  /** Права из токена — объединение по всем ролям пользователя в IAM. */
  permissions: string[]
  /** Своё подразделение (attributes.subdivision_utp_id); пусто у сторонних сотрудников. */
  ownSubdivisionId: string
  authError: string
}

export const useAuthStore = defineStore('auth', {
  state: (): IState => {
    return {
      token: '',
      passCode: '',
      passCodeSubject: '',
      subject: '',
      permissions: [],
      ownSubdivisionId: '',
      authError: '',
    }
  },
  actions: {
    setSSOUser(user: MechtaIDUser) {
      if (this.passCodeSubject !== user.subject) {
        this.passCode = ''
      }
      const attributes = (user.profile.attributes ?? {}) as Record<string, unknown>

      this.passCodeSubject = user.subject
      this.subject = user.subject
      this.token = user.accessToken
      // IdP присылает null вместо пустого списка.
      this.permissions = [...(user.permissions ?? [])]
      this.ownSubdivisionId = String(attributes.subdivision_utp_id ?? '')
      this.authError = ''
    },
    clearSSO() {
      this.token = ''
      this.subject = ''
      this.permissions = []
      this.ownSubdivisionId = ''
    },
    setPassCode(data: string) {
      this.passCode = data
      this.passCodeSubject = this.subject
    },
    setAuthError(message: string) {
      this.authError = message
    },
  },
  persist: {
    pick: ['passCode', 'passCodeSubject'],
  },
})
